import React from 'react';
import PropTypes from 'prop-types';

import Page from '../Page';

const Article = props => {
  const { html: __html, title } = props;
  return (
    <Page {...props}>
      <h3 className="title">{title}</h3>
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html }} // eslint-disable-line react/no-danger
      />
    </Page>
  );
};

Article.propTypes = {
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

Article.defaultProps = {};

export default Article;



// WEBPACK FOOTER //
// ./src/components/Article/index.js